(function (angular) {
    'use strict';

    angular.module('reports')
        .factory('sharedChannelService',['channelsProvider',
        function (channelsProvider) {

                var getChannels = function (mode, primaryValue, secondaryValue) {
                    var channels = {
                        sms: {
                            id: 'sms',
                            label: channelsProvider.sms.name,
                            configured: true,
                            color: ['#07be6b', '#12f990'],
                            statuses: [{
                                id: 'success',
                                label: 'Sent'
                            }, {
                                id: 'delivered',
                                label: 'Delivered'
                            }, {
                                id: 'queued',
                                label: 'Queued'
                            }, {
                                id: 'filtered',
                                label: 'Filtered'
                            }, {
                                id: "expired",
                                label: "Expired"
                            }, {
                                id: "undeliverable",
                                label: "Undeliverable"
                            }, {
                                id: 'inbound',
                                label: 'Inbound'
                            }],
                            displayCountrySplit: true,
                            displayDeliveryOverTime: true,
                            primaryCircle: {
                                color: '#429321',
                                text: "Delivery rate",
                                id: 'delivered',
                                value: primaryValue
                            },
                            secondaryCircle: {
                                color: '#cb2d3e',
                                text: "Undeliverable rate",
                                id: 'undeliverable',
                                value: secondaryValue
                            }
                        },
                        fbMessenger: {
                            id: 'fbMessenger',
                            label: channelsProvider.fbMessenger.name,
                            displayDeliveryOverTime: true,
                            color: ['#0056c7', '#01b8ff'],
                            configured: false,
                            statuses: [{
                                id: 'success',
                                label: 'Sent'
                            }, {
                                id: 'delivered',
                                label: 'Delivered'
                            }, {
                                id: 'read',
                                label: 'Read'
                            }, {
                                id: 'inbound',
                                label: 'Inbound'
                            }],
                            primaryCircle: {
                                color: '#429321',
                                text: "Delivery rate",
                                id: 'delivered',
                                value: primaryValue
                            },
                            secondaryCircle: {
                                color: '#0ed2f7',
                                text: "Read rate",
                                id: 'read',
                                value: secondaryValue
                            }
                        },
                        email: {
                            id: 'email',
                            label: channelsProvider.email.name,
                            displayDeliveryOverTime: true,
                            color: ['#ff6604', '#fabb49'],
                            configured: false,
                            statuses: [{
                                id: 'success',
                                label: 'Sent'
                            }, {
                                id: 'delivered',
                                label: 'Delivered'
                            }, {
                                id: 'read',
                                label: 'Read'
                            }, {
                                id: "undeliverable",
                                label: "Undeliverable"
                            }, {
                                id: 'inbound',
                                label: 'Inbound'
                            }],
                            primaryCircle: {
                                color: '#429321',
                                text: "Delivery rate",
                                id: 'delivered',
                                value: primaryValue
                            },
                            secondaryCircle: {
                                color: '#cb2d3e',
                                text: "Undeliverable rate",
                                id: 'undeliverable',
                                value: secondaryValue
                            }
                        },
                        appMessaging: {
                            id: 'appMessaging',
                            label: 'App Messaging',
                            displayDeliveryOverTime: true,
                            color: ['#f84295', '#d1005f'],
                            configured: false,
                            statuses: [{
                                id: 'success',
                                label: 'Sent'
                            }, {
                                id: 'delivered',
                                label: 'Delivered'
                            }, {
                                id: 'read',
                                label: 'Read'
                            }, {
                                id: 'inbound',
                                label: 'Inbound'
                            }],
                            primaryCircle: {
                                color: '#429321',
                                text: "Delivery rate",
                                id: 'delivered',
                                value: primaryValue
                            },
                            secondaryCircle: {
                                color: '#0ed2f7',
                                text: "Read rate",
                                id: 'read',
                                value: secondaryValue
                            }
                        },
                        twitterDm: {
                            id: 'twitterDm',
                            label: channelsProvider.twitterDm.name,
                            color: ['#0082D2', '#1DA1F2'],
                            configured: false,
                            statuses: [{
                                id: 'success',
                                label: 'Sent'
                            }, {
                                id: 'read',
                                label: 'Read'
                            }, {
                                id: 'inbound',
                                label: 'Inbound'
                            }],
                            primaryCircle: {
                                color: '#429321',
                                text: "Sent rate",
                                id: 'success',
                                value: primaryValue
                            },
                            secondaryCircle: {
                                color: '#0ed2f7',
                                text: "Read rate",
                                id: 'read',
                                value: secondaryValue
                            }
                        },
                        whatsApp: {
                            id: 'whatsApp',
                            label: channelsProvider.whatsApp.name,
                            color: ['#25D366', '#006827'],
                            configured: false,
                            statuses: [{
                                id: 'success',
                                label: 'Sent'
                            }, {
                                id: 'delivered',
                                label: 'Delivered'
                            }, {
                                id: 'read',
                                label: 'Read'
                            }, {
                                id: 'inbound',
                                label: 'Inbound'
                            }],
                            primaryCircle: {
                                color: '#429321',
                                text: "Delivery rate",
                                id: 'delivered',
                                value: primaryValue
                            },
                            secondaryCircle: {
                                color: '#0ed2f7',
                                text: "Read rate",
                                id: 'read',
                                value: secondaryValue
                            }
                        },
                        rcs: {
                            id: 'rcs',
                            label: channelsProvider.rcs.name,
                            color: ['#333333', '#999999'],
                            configured: false,
                            statuses: [{
                                id: 'success',
                                label: 'Sent'
                            }, {
                                id: 'delivered',
                                label: 'Delivered'
                            }, {
                                id: 'read',
                                label: 'Read'
                            }, {
                                id: 'inbound',
                                label: 'Inbound'
                            }],
                            primaryCircle: {
                                color: '#429321',
                                text: "Delivery rate",
                                id: 'delivered',
                                value: primaryValue
                            },
                            secondaryCircle: {
                                color: '#0ed2f7',
                                text: "Read rate",
                                id: 'read',
                                value: secondaryValue
                            }
                        }
                    };
                    return mode === 'singleChannel' ? channels : Object.values(channels);
                };

                function filterChannelData(mode, channelsData, channels, primaryValue, secondaryValue) {
                    channelsData.forEach(function (channel) {
                        var configuredChannel = _.find(channels, function (o) {
                            return channel.id == o.id;
                        });

                        if (configuredChannel) {
                            configuredChannel.configured = true;

                        } else {
                            var channelConfig = {
                                id: channel.id,
                                label: channel.name,
                                displayDeliveryOverTime: true,
                                color: ['#2B97EF', '#5AB2FA'],
                                configured: true,
                                statuses: [{
                                    id: 'success', 
                                    label: 'Sent'
                                },{
                                    id: 'delivered',
                                    label: 'Delivered'
                                },{
                                    id: 'read',
                                    label: 'Read'
                                },{
                                    id: 'inbound',
                                    label: 'Inbound'
                                }],
                                primaryCircle : {
                                    color: '#429321',
                                    text: "Delivery rate",
                                    id: 'delivered',
                                    value: primaryValue
                                },
                                secondaryCircle: {
                                    color: '#0ed2f7',
                                    text: "Read rate",
                                    id: 'read',
                                    value: secondaryValue
                                }
                            };
                            if(mode === 'singleChannel'){
                                channels[channel.id] = channelConfig;
                            } else {
                                channels.push(channelConfig);
                            }
                        }

                    });
                }


                //generate color based on string - this allow to have same color to same country without saving in database

                function stringToColor(str) {
                    var hash = 0;
                    for (var i = 0; i < str.length; i++) {
                        hash = str.charCodeAt(i) + ((hash << 5) - hash);
                    }
                    var colour = '#';
                    for (i = 0; i < 3; i++) {
                        var value = (hash >> (i * 8)) & 0xFF;
                        colour += ('00' + value.toString(16)).substr(-2);
                    }
                    return colour;
                }

                function shadeColor(color, percent) {
                    var f = parseInt(color.slice(1), 16), t = percent < 0 ? 0 : 255, p = percent < 0 ? percent * -1 : percent, R = f >> 16, G = f >> 8 & 0x00FF, B = f & 0x0000FF;
                    return "#" + (0x1000000 + (Math.round((t - R) * p) + R) * 0x10000 + (Math.round((t - G) * p) + G) * 0x100 + (Math.round((t - B) * p) + B)).toString(16).slice(1);
                }
                var fac = {
                    filterChannelData: filterChannelData,
                    getChannels: getChannels,
                    shadeColor: shadeColor,
                    stringToColor: stringToColor

                };

                return fac;
   

            }
        ]);
})(window.angular);